export const DELETE_JOBS = 'concurrency/DELETE_JOBS'
export const deleteJobs = onShowSnackbar => ({
  type: DELETE_JOBS,
  payload: { onShowSnackbar },
})

export const SET_ARCHIVED_JOBS = 'concurrency/SET_ARCHIVED_JOBS'
export const setArchivedJobs = (onShowSnackbar, archived) => ({
  type: SET_ARCHIVED_JOBS,
  payload: { onShowSnackbar, archived },
})

export const DELETE_CANDIDATES = 'concurrency/DELETE_CANDIDATES'
export const deleteCandidates = (
  { projectId, status },
  { onShowSnackbar },
) => ({
  type: DELETE_CANDIDATES,
  payload: { projectId, status, onShowSnackbar },
})

export const IMPORT_CANDIDATES = 'concurrency/IMPORT_CANDIDATES'
export const importCandidates = (
  { candidates, projectId },
  { onShowSnackbar, onSuccess },
) => ({
  type: IMPORT_CANDIDATES,
  payload: { candidates, projectId, onShowSnackbar, onSuccess },
})

export const SELECT_CANDIDATES = 'concurrency/SELECT_CANDIDATES'
export const selectCandidates = ({ projectId }, { onShowSnackbar }) => ({
  type: SELECT_CANDIDATES,
  payload: { projectId, onShowSnackbar },
})

export const SEND_MESSAGES = 'concurrency/SEND_MESSAGES'
export const sendMessages = (
  { candidates, projectId, workspaceId },
  { onShowSnackbar, onSuccess },
) => ({
  type: SEND_MESSAGES,
  payload: { candidates, projectId, workspaceId, onShowSnackbar, onSuccess },
})

export const MOVE_CANDIDATES = 'concurrency/MOVE_CANDIDATES'
export const moveCandidates = (
  { candidates, project, status },
  { onShowSnackbar, onSuccess },
) => ({
  type: MOVE_CANDIDATES,
  payload: { candidates, project, status, onShowSnackbar, onSuccess },
})
